<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <h3 class="mb-lg-4 mb-3">Billing Information</h3>

      <div class="row">
        <div class="col-lg-6 col-sm-6">
          <div class="form-group mb-4">
            <label class="label text-secondary">Customer Name</label>
            <input
              type="text"
              class="form-control h-55"
              placeholder="Enter Customer Name"
            />
          </div>
        </div>
        <div class="col-lg-6 col-sm-6">
          <div class="form-group mb-4">
            <label class="label text-secondary">Phone Number</label>
            <input
              type="text"
              class="form-control h-55"
              placeholder="Enter Phone Number"
            />
          </div>
        </div>
        <div class="col-lg-6 col-sm-6">
          <div class="form-group mb-4">
            <label class="label text-secondary">Email Address</label>
            <input
              type="email"
              class="form-control h-55"
              placeholder="Enter Email Address"
            />
          </div>
        </div>
        <div class="col-lg-6 col-sm-6">
          <div class="form-group mb-4">
            <label class="label text-secondary">State</label>
            <select
              class="form-select form-control h-55"
              aria-label="Default select example"
            >
              <option selected>select</option>
              <option value="1">Florida</option>
              <option value="2">Wisconsin</option>
              <option value="3">Washington</option>
            </select>
          </div>
        </div>
        <div class="col-lg-6 col-sm-6">
          <div class="form-group mb-4">
            <label class="label text-secondary">City</label>
            <select
              class="form-select form-control h-55"
              aria-label="Default select example"
            >
              <option selected>select</option>
              <option value="1">New York</option>
              <option value="2">Tokyo</option>
              <option value="3">Amsterdam</option>
            </select>
          </div>
        </div>
        <div class="col-lg-6 col-sm-6">
          <div class="form-group mb-4">
            <label class="label text-secondary">ZIP / Postcode</label>
            <input
              type="text"
              class="form-control h-55"
              placeholder="Enter zip postcode"
            />
          </div>
        </div>
        <div class="col-lg-6 col-sm-6">
          <div class="form-group mb-4">
            <label class="label text-secondary">Street Address</label>
            <input
              type="text"
              class="form-control h-55"
              placeholder="Enter Street Address"
            />
          </div>
        </div>
        <div class="col-lg-6 col-sm-6">
          <div class="form-group mb-4">
            <label class="label text-secondary">Country</label>
            <select
              class="form-select form-control h-55"
              aria-label="Default select example"
            >
              <option selected>Select</option>
              <option value="1">USA</option>
              <option value="2">Canada</option>
              <option value="3">Spain</option>
            </select>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="form-group mb-4">
            <label class="label text-secondary">Order Note (optional)</label>
            <textarea
              rows="7"
              class="form-control"
              placeholder="Write your note here...."
            ></textarea>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="d-flex flex-wrap gap-3">
            <button class="btn btn-danger py-2 px-4 fw-medium fs-16 text-white">
              Cancel
            </button>
            <button class="btn btn-primary py-2 px-4 fw-medium fs-16">
              <i class="ri-add-line text-white fw-medium"></i> Create Order
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BillingInformation",
});
</script>
